import template from './dashboard-boolean-filter.component.html';
import type { InteractiveFilter } from '../../InteractiveFilter.model';
import type { IComponentController } from 'angular';

export class DashboardBooleanFilterController implements IComponentController {
	filter!: InteractiveFilter;

	private _value = false;
	$onInit() {
		if (typeof this.filter.value?.[0] === 'boolean') {
			this.value = this.filter.value?.[0];
		}

		this.filter.onChange(() => {
			this.handleExternalChanges();
		});
	}

	private handleExternalChanges() {
		this._value = typeof this.filter.value?.[0] === 'boolean' ? this.filter.value?.[0] : false;
	}

	get value() {
		return this._value;
	}

	set value(newValue: boolean) {
		this._value = newValue;
		if (newValue) {
			this.filter.setValue([true], this.filter.operators.Equals.getFullLabel(this.filter.title, [true]));
		} else {
			this.filter.clear();
		}
	}
}

export const DashboardBooleanFilterComponent = {
	name: 'mxDashboardBooleanFilter',
	controller: DashboardBooleanFilterController,
	controllerAs: 'vm',
	template,
	bindings: {
		filter: '<',
	},
};
